export default __webpack_public_path__ + "static/planning-recommended-2026-40818df1b593a9a0091172aa71c884e2.png";